import React from 'react';
import './Verification.scss';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from "react-router-dom";
import {Status} from "../../common/const/const";
import routes from "../../common/routes/routes";
import {setCode, sendError} from '../../common/redux/actions';

const Verification = ({ switchStatus, authService }) => {
    const [currentCode, setCurrentCode] = React.useState('');
    const email = useSelector(state => state.main.email);
    const history = useHistory();
    const dispatch = useDispatch();

    const onChangeCode = React.useCallback(event => {
        event.preventDefault();
        const { value } = event.currentTarget;
        setCurrentCode(value);
    }, []);

    const onSenCode = React.useCallback(
        async (event) => {
            event.preventDefault();
            await authService.getNewTokens(email, currentCode).then(() => {
                switchStatus(Status.AUTHORIZED);
                dispatch(setCode(''));
                console.log(history);
                history.push(routes.MAIN);
            }).catch(error => {
                dispatch(sendError(error.response.data));
            })
        },
        [authService, currentCode, dispatch, email, history, switchStatus],
    );

    const onRepeatGetCode = React.useCallback(async () => {
        authService.getCode(email).then(result => {
            dispatch(setCode(result.data.code));
        }).catch(error => {
            dispatch(sendError(error.response.data))
        })
    }, [authService, dispatch, email])

    return (
        <form className="Verification__form" name="Verification" onSubmit={onSenCode}>
            <label className="Verification__label" htmlFor="email">
                <span className="Verification__title">{email}</span>
                <input
                    value={currentCode}
                    onChange={onChangeCode}
                    className="Verification__input"
                    id="text"
                    name="text"
                    type="text"
                    placeholder="Введите код из email"
                />
            </label>
            <button onClick={onRepeatGetCode} type="button" className="Verification__btn Verification__btn_refresh">Отправить еще раз</button>
            <button className="Verification__btn" type="submit">
                Вход
            </button>
        </form>
    );
};

export default Verification;
